// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1OpQY","newExpiryDate":"styles_newExpiryDate__HVSpQ","footer":"styles_footer__9GTRS"};